<div class="tk-grid-profile h-full tk-panel-bg">
  <div class="profile-content">
    <div class="profile-content__top">
      <div class="profile-content__top__profile">
        <div class="profile-content__top__profile__avatar">
          <span>{{userInitials}}</span>
        </div>
        <div class="profile-content__top__profile__right">
          <span class="username">
            {{user?.FirstName}} {{user?.LastName}}
          </span>
          <span class="email">
            {{user?.Email}}
          </span>
          <span *ngIf="user?.Phone" class="phone">
            {{user?.Phone}}
          </span>
        </div>
      </div>

      <div class="profile-content__top__menu-list">
        <div 
          *ngFor="let item of menuList"
          (click)="item.onClick()"
          class="profile-content__top__menu-list__item"
        >
          <div class="icon">
            <img [ngStyle]="{'height': item.height}" [src]="item.img" alt="">
          </div>
          <span [ngStyle]="{'color': item.colorText}" class="title">
            {{item.title}}
          </span>
        </div>
      </div>
    </div>
    <div class="profile-content__footer">
      <span class="title">
        {{ 'yourProfile.needHelp' | translate }}
      </span>

      <div class="profile-content__footer__help">
        <span>{{ 'yourProfile.helpDescription' | translate }} <a href="/">serwis&#64;tekom.pl</a>, <span class="phone">+48 609 111 114</span></span>
      </div>
    </div>
  </div>
</div>
